"use client";

import { useLandingConversions } from "@/modules/conversions/use-landing-conversions";
import { Button } from "@ui/components/ui/button";
import Link from "next/link";
import { bookingUrl } from "../common/urls";

export const CtaButtons = ({ authed }: { authed: boolean }) => {
  const { trackBookDemoClicked, trackPrimaryCtaClicked } =
    useLandingConversions();

  return (
    <div className="flex gap-2 items-center">
      {!authed && (
        <Button
          variant="outline"
          asChild
          className="h-7 rounded-lg text-xs outline-none border-none px-3 hidden min-[400px]:flex"
          onClick={() => trackBookDemoClicked("navbar")}
        >
          <Link href={bookingUrl} target="_blank">
            Book a demo
          </Link>
        </Button>
      )}
      <Button
        variant={authed ? "outline" : "default"}
        asChild
        className="text-xs h-7 rounded-lg px-3 border-none"
        onClick={() => trackPrimaryCtaClicked("navbar")}
      >
        <Link href={authed ? "/" : "/auth/login"}>
          {authed ? "Open app" : "Try for free"}
        </Link>
      </Button>
    </div>
  );
};
